// extracted by mini-css-extract-plugin
export default {"modal":"BlockPhotoAdjustmentModal_modal__eJVBY","cropContainer":"BlockPhotoAdjustmentModal_cropContainer__c5tgR","buttonContainer":"BlockPhotoAdjustmentModal_buttonContainer__wWVpC"};